import BackButton from "../../../components/Buttons/BackButton";
import BasicButton from "../../../components/Buttons/BasicButton";
import XsCont from "../../../components/containers/Xs";
import HeaderSignIn from "../../../components/headers/HeaderSignIn";
import BasicForm from "../../../components/textField/BasicForm";
import PasswordField from "../../../components/textField/PasswordField";
import { validationMessage } from "../../../consts/ValidationMessage";
import { getCognitoUser, getUserPool } from "../../../utils/cognitoUtils";
import {
  isExactPasswordFormat,
  validateRequiredFields,
  ValidationErrors,
} from "../../../utils/validationUtils";
import { Typography, Box, Container } from "@mui/material";
import { CognitoUser } from "amazon-cognito-identity-js";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

const PasswordResetPage: FC = () => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [form, setForm] = useState({
    resetCode: "",
    newPassword: "",
    confirmPassword: "",
    loginId: sessionStorage.getItem("loginId") || "",
  });

  const [resetFlag, setResetFlag] = useState(false);

  const [errors, setErrors] = useState<ValidationErrors>({});
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleResend: () => void = (): void => {
    try {
      const cognitoUser = new CognitoUser({
        Username: form.loginId,
        Pool: getUserPool(),
      });
      const resendResult = () => {
        setResetFlag(true);
      };
      cognitoUser.forgotPassword({
        onSuccess: () => {
          resendResult();
        },
        onFailure: () => {
          resendResult();
        },
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      navigate("/error");
    }
  };

  const handleBack: () => void = (): void => {
    navigate("/pw/forgot");
  };
  const validate: () => boolean = (): boolean => {
    const requiredFields: string[] = [
      "resetCode",
      "newPassword",
      "confirmPassword",
    ];
    const errorMessages = {
      resetCode: `リセットコード${validationMessage.REQUIRED}`,
      newPassword: `新しいパスワード${validationMessage.REQUIRED}`,
      confirmPassword: `新しいパスワード(確認用)${validationMessage.REQUIRED}`,
    };

    const newErrors: ValidationErrors = validateRequiredFields(
      form,
      requiredFields,
      errorMessages
    );
    const newPassword: string = form.newPassword;
    if (!newErrors.newPassword && !newErrors.confirmPassword) {
      if (newPassword !== form.confirmPassword) {
        newErrors.confirmPassword = validationMessage.PW_CONFIRM;
      }
      if (newPassword.length < 10) {
        newErrors.newPassword = validationMessage.PW_LENGTH;
      }
      if (!isExactPasswordFormat(newPassword)) {
        newErrors.newPassword = validationMessage.PW_FORMAT;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClickButton = () => {
    if (!validate()) return;

    try {
      const cognitoUser = getCognitoUser(form.loginId);

      cognitoUser.confirmPassword(form.resetCode, form.newPassword, {
        onSuccess: () => {
          navigate("/pw/change/comp");
        },
        onFailure: () => {
          setErrors({
            resetCode: "パスワードリセットに失敗しました。再度お試しください。",
          });
        },
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <>
      <HeaderSignIn />
      <XsCont>
        <Box mt={10} textAlign="center">
          <Typography variant="h5" gutterBottom>
            新パスワード入力
          </Typography>
        </Box>
      </XsCont>
      <Container
        maxWidth="sm"
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        {resetFlag ? (
          <Box mt={8} sx={{ backgroundColor: "#e0f2f7", padding: 2 }}>
            <Typography variant="body1" gutterBottom>
              パスワードのリセットコードを再送しました。
              <br />
              ご確認ください。
              <br />
              メールが届かない場合は迷惑メールフォルダの確認、もしくはログイン
              ID を見直し、再度パスワードリセットを実行してください。
            </Typography>
          </Box>
        ) : (
          <Box mt={8} sx={{ backgroundColor: "#f5f5f5", padding: 2 }}>
            <Typography variant="body1" gutterBottom>
              パスワードのリセットコードを送信しました。
              <br />
              メールが届かない場合は迷惑メールフォルダの確認、もしくはログイン
              ID を見直し、再度パスワードリセットを実行してください。
            </Typography>
          </Box>
        )}
      </Container>
      <XsCont>
        <Box
          component="form"
          mt={5}
          display="flex"
          flexDirection="column"
          gap={3}
        >
          <BasicForm
            label={"リセットコード"}
            name={"resetCode"}
            value={form.resetCode}
            onChange={handleChange}
            isRequired={true}
            error={!!errors.resetCode}
            helperText={errors.resetCode}
          />
          <PasswordField
            label="新しいパスワード"
            name="newPassword"
            value={form.newPassword}
            error={!!errors.newPassword}
            helperText={errors.newPassword}
            onChange={handleChange}
            showPassword={showPassword}
            onTogglePasswordVisibility={handleClickShowPassword}
          />
          <PasswordField
            label="新しいパスワード(確認用)"
            name="confirmPassword"
            value={form.confirmPassword}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword}
            onChange={handleChange}
            showPassword={showPassword}
            onTogglePasswordVisibility={handleClickShowPassword}
          />
          <BasicButton onClick={handleClickButton} mt={5}>
            変更
          </BasicButton>
          <BackButton onClick={handleResend} mt={0}>
            リセットコード再送
          </BackButton>
          <BackButton onClick={handleBack} mt={0}>
            ログインIDを見直す
          </BackButton>
        </Box>
      </XsCont>
    </>
  );
};

export default PasswordResetPage;
